// 高级筛选器
import { Component, Vue, Emit, PropSync } from 'vue-property-decorator'
@Component({ name: 'highFilter' })
export default class HighFilter extends Vue {
  @PropSync('searchObj') _searchObj: any
  private showAddBox = false
  private addChoosed = null
  private filterData: any = [

  ]

  /**
   * [description] 关闭按钮点击
   */
  @Emit()
  private onCloseClick () {
    //
  }

  @Emit()
  private throwResult (data: any) {
    return data
  }

  created () {
    let filterResult: any = null
    const data: any = sessionStorage.getItem('filterData')
    filterResult = JSON.parse(data)
    if (filterResult && this.$route.name === 'list') { // 审批列表页缓存
      this.filterData = filterResult
    }
  }

  /**
   * [description] 添加一个筛选表单
   */
  private onAddClick () {
    if (this.addChoosed === null) return
    const index = this._searchObj.findIndex((item: any) => { return item.nameCn === this.addChoosed })
    const delObj = this._searchObj.splice(index, 1)[0]
    this.filterData.push(delObj)
    this.addChoosed = null
    this.showAddBox = false
  }

  private onAddClick1 () {
    this.filterData.push({})
  }

  private changeselect (item1: any, index1: any) {
    if (this.filterData.find((item: any) => item1.addChoosed === item.nameCn)) {
      item1.addChoosed = ''
      return
    }
    const delObj = this._searchObj.find((item: any) => item.nameCn === item1.addChoosed)
    this.$set(delObj, 'addChoosed', item1.addChoosed)
    this.$nextTick(() => {
      Vue.set(this.filterData, index1, delObj)
    })
  }

  /**
   * [description] 筛选item被删掉
   */
  private onRemoveItem (item: any) {
    const index = this.filterData.findIndex((data: any) => { return data.nameEn === item.nameEn })
    const delObj = this.filterData.splice(index, 1)[0]
    this._searchObj.push(delObj)
  }

  /**
   * [description] ok点击 传出结果 并开始筛选
   */
  private onOkClick () {
    const checkList = this.filterData.filter((item: any) => {
      return item.searchMethodChoosed !== 'isNull' && (item.value === undefined || item.value.length === 0)
    })
    if (checkList.length > 0) { this.$message({ message: '内容不能为空', type: 'warning' }); return }

    const result = this.filterData.map((item: any) => {
      return {
        nameEn: item.nameEn,
        searchMethod: item.searchMethodChoosed || null,
        value: Array.isArray(item.value) ? item.value : item.value ? item.value.split('/') : []
      }
    })
    const filterResult = JSON.stringify(this.filterData) // 转化为JSON字符串
    sessionStorage.setItem('filterData', filterResult)
    this.throwResult(result)
  }
}
